var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightenTones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-brightnes"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Benefits/Moisturizes",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-brightnes"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "#27CAE3",
    xlinkHref: "#path-1-brightnes"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.04,
    stroke: "#00ADC6",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22,13.9992 C20.894,13.9992 20,13.1052 20,11.9992 C20,10.8932 20.894,9.9992 22,9.9992 C23.106,9.9992 24,10.8932 24,11.9992 C24,13.1052 23.106,13.9992 22,13.9992 M20,26.9992 C18.344,26.9992 17,25.6552 17,23.9992 C17,22.3432 18.344,20.9992 20,20.9992 C21.656,20.9992 23,22.3432 23,23.9992 C23,25.6552 21.656,26.9992 20,26.9992 M16,12.9992 C14.894,12.9992 14,12.1052 14,10.9992 C14,9.8932 14.894,8.9992 16,8.9992 C17.106,8.9992 18,9.8932 18,10.9992 C18,12.1052 17.106,12.9992 16,12.9992 M12,22.9992 C10.894,22.9992 10,22.1052 10,20.9992 C10,19.8932 10.894,18.9992 12,18.9992 C13.106,18.9992 14,19.8932 14,20.9992 C14,22.1052 13.106,22.9992 12,22.9992 M9.501,14.9992 C9.501,13.8932 10.396,12.9992 11.501,12.9992 C12.607,12.9992 13.501,13.8932 13.501,14.9992 C13.501,16.1052 12.607,16.9992 11.501,16.9992 C10.396,16.9992 9.501,16.1052 9.501,14.9992 M28.881,23.7432 C28.469,23.3622 27.862,23.2682 27.344,23.1812 C26.625,23.0622 26.351,22.9312 25.932,22.5562 C25.038,21.7622 25.038,20.6122 25.932,19.8182 L27.825,18.1372 C30.725,15.5752 30.725,11.3742 27.825,8.8122 C25.688,6.9312 22.819,6.0002 19.838,6.0002 C16.357,6.0002 12.72,7.2692 9.914,9.7562 C4.695,14.3682 4.695,21.9242 9.914,26.5372 C12.508,28.8302 16.007,29.9742 19.47,29.9992 L19.575,29.9992 C23.038,29.9992 26.45,28.8802 28.875,26.7242 C29.775,25.9302 29.625,24.4372 28.881,23.7432",
    id: "Fill-1-brightnes",
    fillOpacity: 0.65,
    fill: "#27CAE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightenTones);
export default __webpack_public_path__ + "static/media/BrightenTones.f21aa32fd2c09901e23552e6897b1b20.svg";
export { ForwardRef as ReactComponent };